"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiLineLabel = exports.Label = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_multi_clamp_1 = __importDefault(require("react-multi-clamp"));
exports.Label = styled_components_1.default.label `
  text-align: right;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  &::first-letter {
    text-transform: capitalize;
  }
`;
const MultiLineLabel = (props) => {
    const [showTooltip, setShowTooltip] = (0, react_1.useState)(false);
    const labelText = `${props.label || props.name}${props.required && !props.disabled ? " *" : ""}`;
    return (
    // overflow is set as the height of multi line text is slightly greater
    // than the input fields. Without this, the vertical margins between fields
    // would increased for multi line labels as the height would be greater.
    react_1.default.createElement(exports.Label, { style: {
            height: "30px",
            overflow: "visible",
            whiteSpace: "wrap",
            alignContent: "center",
            alignSelf: "flex-start",
        }, htmlFor: props.name, title: showTooltip ? labelText : undefined },
        react_1.default.createElement(react_multi_clamp_1.default, { clamp: 2, splitByWords: true, onClampEnd: (result) => setShowTooltip(result.didClamp) }, labelText)));
};
exports.MultiLineLabel = MultiLineLabel;
//# sourceMappingURL=Label.js.map